export default __webpack_public_path__ + "static/media/logo.a16af518.png";